'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isOver"];
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIListingPage from 'UIComponents/page/UIListingPage';
import { ObjectCategory, RequestStatus } from 'FileManagerCore/Constants';
import { getDeselectImageToEditAction, uploadEditedImage, uploadResizedImage } from 'FileManagerCore/actions/Files';
import { setDocumentTitle } from '../utils/documentTitle';
import { fetchFiles, uploadDashboardFiles } from '../actions/Files';
import { search, navigate, selectFile, changePage, archive, changeSort, openFileDetailsPanel, filterFileType, setPageSize } from '../actions/Actions';
import { addFileBulkSelection, addFolderBulkSelection, clearBulkSelection, removeFileBulkSelection, removeFolderBulkSelection } from '../actions/Bulk';
import { getSelectedFile, getSelectedObjectIds } from '../selectors/Selection';
import { getCurrentFolder, getFileDetailsIdFromUrl, getFolderIdFromUrl, getHasAccessToFolder } from '../selectors/FoldersAndFiles';
import FileFolderTable from '../components/FileFolderTable';
import Toolbar from '../components/Toolbar';
import PageTabs from '../components/PageTabs';
import DashboardNoAccess from '../components/DashboardNoAccess';
import DashboardActionBar from '../components/DashboardActionBar';
import LimitsModalsContainer from './LimitsModalsContainer';
import { FILE_MANAGER_DASHBOARD_DEFAULT_ACCESS, Tabs } from '../Constants';
import EmptyDashboard from '../components/EmptyDashboard';
import { fetchLimits } from 'FileManagerCore/actions/Limits';
import { getHasVideoIntegrationScope, getUserEmailAddress, getHasFileManagerAccessScope, selectIsUngatedForBackendPoweredPagination } from 'FileManagerCore/selectors/Auth';
import { getAreFilesUploading } from 'FileManagerCore/selectors/UploadingFiles';
import { getSelectedImageToEdit } from 'FileManagerCore/selectors/EditAndCreateImage';
import FileDragAndDrop from 'FileManagerCore/components/FileDragAndDrop';
import UsageTracker from '../utils/usageTracker';
import getQueryFromLocation from '../utils/getQueryFromLocation';
import EmptyFolder from '../components/EmptyFolder';
import FolderNotFound from '../components/FolderNotFound';
import { getDashboardUrlParams, shouldRefreshDashboard } from '../utils/urls';
import { getSearchQueryFromUrl } from '../selectors/Query';
import { FOLDER_ROW_CLASSNAME, ROW_CLASSNAME } from '../components/FileFolderTableRow';
import DashboardHeader from '../components/DashboardHeader';
import NoAccessAsset from '../components/NoAccessAsset';
import { getPageSize } from '../selectors/pageSize';
import AsyncImageEditor from '../components/codeSplitting/AsyncImageEditor';
import { fetchFoldersByParentId } from 'FileManagerCore/actions/FolderFetch';
import { parseQueryObject } from '../utils/location';
import { dashboardDidMount } from '../actions/ActionsTyped';
import { fetchFilesAndFolders as fetchFilesAndFoldersAction } from '../actions/FilesAndFolders';
import { getCurrentPageOfFoldersAndFiles, getFetchFilesAndFoldersRequestStatus, getIsFetchingMoreFilesAndFolders } from '../selectors/FilesAndFoldersTable';
import { ConfirmNavigation } from '../components/ConfirmNavigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Dashboard extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isStartState: true
    };
    this.handleFetchSearch = value => {
      const {
        dispatch
      } = this.props;
      dispatch(search(value));
    };
    this.handleClearSearch = event => {
      event.preventDefault();
      this.handleFileTypeFilterChange(null);
      this.handleFetchSearch('');
      UsageTracker.track('fileManagerExploreFiles', {
        action: 'clear-search'
      });
    };
    this.handleArchiveFilterChange = event => {
      const {
        dispatch
      } = this.props;
      dispatch(archive(event.target.value));
    };
    this.handleFileTypeFilterChange = (fileType, isHublVideo) => {
      const {
        dispatch
      } = this.props;
      dispatch(filterFileType(fileType, isHublVideo));
    };
    this.handleSelectFile = file => {
      const {
        dispatch
      } = this.props;
      if (file) {
        dispatch(openFileDetailsPanel(file.get('id')));
      } else {
        dispatch(selectFile());
      }
    };
    this.handleAddFileBulkSelection = fileIds => {
      const {
        dispatch
      } = this.props;
      dispatch(addFileBulkSelection(fileIds));
    };
    this.handleAddFolderBulkSelection = folderIds => {
      const {
        dispatch
      } = this.props;
      dispatch(addFolderBulkSelection(folderIds));
    };
    this.handleRemoveFileBulkSelection = fileIds => {
      const {
        dispatch
      } = this.props;
      dispatch(removeFileBulkSelection(fileIds));
    };
    this.handleRemoveFolderBulkSelection = folderIds => {
      const {
        dispatch
      } = this.props;
      dispatch(removeFolderBulkSelection(folderIds));
    };
    this.handleClearBulkSelection = () => {
      const {
        dispatch
      } = this.props;
      dispatch(clearBulkSelection());
    };
    this.handleDropFiles = files => {
      const {
        currentFolder,
        dispatch
      } = this.props;
      dispatch(uploadDashboardFiles(files, {
        folderId: currentFolder ? currentFolder.get('id') : null
      }));
      UsageTracker.track('fileManagerManageFiles', {
        action: 'upload',
        target: 'dashboard-drop',
        count: files.length
      });
    };
    this.handleDropFilesOnFolder = (files, folder) => {
      const {
        dispatch
      } = this.props;
      dispatch(uploadDashboardFiles(files, {
        folderId: folder.get('id')
      }));
      UsageTracker.track('fileManagerManageFiles', {
        action: 'upload',
        target: 'dashboard-folder-row-drop',
        count: files.length
      });
    };
    this.handleSortChange = options => {
      const {
        dispatch
      } = this.props;
      dispatch(changeSort(options));
    };
    this.handlePageChange = nextPage => {
      const {
        dispatch,
        folderId
      } = this.props;
      dispatch(navigate({
        page: nextPage,
        folderId
      }));
    };
    this.handleSetPageSize = pageSize => {
      const {
        dispatch,
        folderId
      } = this.props;
      dispatch(setPageSize(pageSize));
      dispatch(navigate({
        page: 1,
        folderId
      }));
    };
  }
  componentDidMount() {
    const {
      dispatch,
      fileDetailsId,
      hasVideoIntegrationScope,
      isUngatedForBackendPoweredPagination
    } = this.props;
    setDocumentTitle();
    if (hasVideoIntegrationScope && !isUngatedForBackendPoweredPagination) {
      dispatch(fetchLimits());
    }

    // If ungated, fetch files and folders before opening the details panell
    if (isUngatedForBackendPoweredPagination) {
      dispatch(dashboardDidMount(this.props.location)).then(() => {
        if (fileDetailsId) {
          dispatch(openFileDetailsPanel(fileDetailsId));
        }
      }).catch(error => {
        throw error;
      });
    } else {
      // Otherwise, files and folders will have already been fetched in Application.js, so we can proceed with opening the details panel
      if (fileDetailsId) {
        dispatch(openFileDetailsPanel(fileDetailsId));
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      dispatch,
      status
    } = this.props;
    const prevUrlParams = getDashboardUrlParams(prevProps);
    const currentUrlParams = getDashboardUrlParams(this.props);
    const {
      page
    } = currentUrlParams;
    const pageCount = this.getPageCount();
    if (page !== 1 && status === RequestStatus.SUCCEEDED && page > pageCount) {
      dispatch(navigate({
        page: pageCount || 1
      }, true));
    }
    if (shouldRefreshDashboard(currentUrlParams, prevUrlParams)) {
      if (prevState.isStartState) {
        console.log('Not refreshing dashboard in start state');
        return;
      }
      this.fetchFilesAndFolders(currentUrlParams);
    } else if (page !== prevUrlParams.page) {
      dispatch(changePage(currentUrlParams));
    }
  }
  static getDerivedStateFromProps(props) {
    const rawQueryParams = parseQueryObject(props.location);
    return {
      isStartState: !props.total && !props.searchQuery && !props.folderId && rawQueryParams.archived === undefined && rawQueryParams.fileType === undefined && rawQueryParams.isHublVideo === undefined
    };
  }
  getPageCount() {
    const {
      total,
      pageSize
    } = this.props;
    return total > 0 ? Math.ceil(total / pageSize) : 0;
  }
  getIsStartState({
    page,
    fileType
  }) {
    const {
      status,
      total,
      searchQuery
    } = this.props;
    return (status === RequestStatus.SUCCEEDED || status === RequestStatus.NOTFOUND) && !total && !searchQuery && !fileType && page === 1;
  }
  fetchFilesAndFolders(options) {
    const {
      dispatch,
      isUngatedForBackendPoweredPagination
    } = this.props;
    if (isUngatedForBackendPoweredPagination) {
      dispatch(fetchFilesAndFoldersAction(options, true /* initialFetch */));
      return;
    }
    dispatch(fetchFiles(options));
    if (options.folderId) {
      dispatch(fetchFoldersByParentId(options.folderId));
    }
  }
  renderDashboardActionBar(queryParams) {
    const {
      currentFolder
    } = this.props;
    return /*#__PURE__*/_jsx(DashboardActionBar, {
      isArchivedFilterApplied: queryParams.archived,
      onFetchSearch: this.handleFetchSearch,
      onArchiveFilterChange: this.handleArchiveFilterChange,
      onFileTypeFilterChange: this.handleFileTypeFilterChange,
      isStartState: this.getIsStartState(queryParams) && !currentFolder
    });
  }
  renderToolbar(queryParams) {
    const {
      searchQuery
    } = this.props;
    return /*#__PURE__*/_jsx(Toolbar, {
      searchText: searchQuery,
      onClearSearch: this.handleClearSearch,
      onPageChange: this.handlePageChange,
      fileTypeFilterValue: queryParams.fileType,
      isHubLVideoQueryParamValue: queryParams.isHublVideo
    });
  }
  renderFileFolderTable({
    orderBy,
    sortDirection,
    page,
    fileType
  }) {
    const {
      status,
      objects,
      searchQuery,
      total,
      selectedFile,
      bulkSelectedObjectIds,
      fetchingMoreFiles,
      pageSize,
      areFilesUploading
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ConfirmNavigation, {
        enable: areFilesUploading
      }), /*#__PURE__*/_jsx(FileFolderTable, {
        orderBy: orderBy,
        sortDirection: sortDirection,
        searchText: searchQuery,
        objects: objects,
        total: total,
        page: page,
        status: status,
        fetchingMoreFiles: fetchingMoreFiles,
        selectedFile: selectedFile,
        bulkSelectedObjectIds: bulkSelectedObjectIds,
        onPageChange: this.handlePageChange,
        onSortChange: this.handleSortChange,
        onDropFiles: this.handleDropFilesOnFolder,
        onSelectFile: this.handleSelectFile,
        onAddFileBulkSelection: this.handleAddFileBulkSelection,
        onAddFolderBulkSelection: this.handleAddFolderBulkSelection,
        onRemoveFileBulkSelection: this.handleRemoveFileBulkSelection,
        onRemoveFolderBulkSelection: this.handleRemoveFolderBulkSelection,
        onClearBulkSelection: this.handleClearBulkSelection,
        onSetPageSize: this.handleSetPageSize,
        pageSize: pageSize,
        fileTypeQuery: fileType,
        areFilesUploading: areFilesUploading
      })]
    });
  }
  renderEmpty({
    archived
  }) {
    const {
      currentFolder,
      hasVideoIntegrationScope,
      status,
      folderId
    } = this.props;
    if (status === RequestStatus.NOTFOUND || folderId && !currentFolder) {
      return /*#__PURE__*/_jsx(FolderNotFound, {});
    }
    if (currentFolder || archived) {
      return /*#__PURE__*/_jsx(EmptyFolder, {
        currentFolder: currentFolder,
        isArchivedFilterApplied: archived
      });
    }
    return /*#__PURE__*/_jsx(EmptyDashboard, {
      archived: archived,
      hasVideoIntegrationScope: hasVideoIntegrationScope
    });
  }
  renderHeader() {
    const {
      currentFolder,
      objects,
      hasAccessToAsset
    } = this.props;
    return /*#__PURE__*/_jsx(DashboardHeader, {
      currentFolder: currentFolder,
      objects: objects,
      hasAccess: hasAccessToAsset
    });
  }
  renderStartState(queryParams) {
    return /*#__PURE__*/_jsxs("div", {
      children: [this.renderDashboardActionBar(queryParams), this.renderToolbar(queryParams), this.renderEmpty(queryParams)]
    });
  }
  renderBody() {
    const queryParams = getQueryFromLocation(this.props.location);
    if (!this.props.hasAccessToAsset) {
      return /*#__PURE__*/_jsx(NoAccessAsset, {
        category: this.props.fileDetailsId ? ObjectCategory.FILE : ObjectCategory.FOLDER
      });
    }
    if (this.getIsStartState(queryParams)) {
      return this.renderStartState(queryParams);
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(LimitsModalsContainer, {}), this.renderDashboardActionBar(queryParams), this.renderToolbar(queryParams), /*#__PURE__*/_jsx("main", {
        className: "main",
        children: this.renderFileFolderTable(queryParams)
      })]
    });
  }
  render() {
    const {
      imgToEditSelected,
      dispatch,
      hasFileManagerAccess,
      areFilesUploading,
      hasAccessToAsset
    } = this.props;
    if (!hasFileManagerAccess) {
      return /*#__PURE__*/_jsx(UIListingPage, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `FileManagerDashboard.app.filesTitle`
        }),
        children: /*#__PURE__*/_jsx(DashboardNoAccess, {})
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(FileDragAndDrop, {
        onDropFiles: this.handleDropFiles,
        ignoreTargetSelector: `.${ROW_CLASSNAME}.${FOLDER_ROW_CLASSNAME}`,
        disabled: !hasAccessToAsset,
        children: _ref => {
          let {
              isOver
            } = _ref,
            props = _objectWithoutPropertiesLoose(_ref, _excluded);
          return /*#__PURE__*/_jsxs("div", Object.assign({
            className: "dashboard--wrapper",
            "data-uploading": areFilesUploading
          }, props, {
            children: [/*#__PURE__*/_jsx("div", {
              className: 'dashboard--drop-target' + (isOver ? " is-over" : "")
            }), setupCsat('FILE_MANAGER_PAGE_VIEW'), /*#__PURE__*/_jsxs(UIListingPage, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `FileManagerDashboard.app.filesTitle`
              }),
              tabs: /*#__PURE__*/_jsx(PageTabs, {
                activeTab: Tabs.DASHBOARD
              }),
              headerComponent: this.renderHeader(),
              children: [this.renderBody(), imgToEditSelected && /*#__PURE__*/_jsx(AsyncImageEditor, {
                onClose: () => dispatch(getDeselectImageToEditAction()),
                onCropSave: (file, fileName, fileFolderId) => dispatch(uploadEditedImage(file, fileName, fileFolderId, FILE_MANAGER_DASHBOARD_DEFAULT_ACCESS)),
                onResizeSave: (fileId, newWidth) => dispatch(uploadResizedImage(fileId, newWidth, FILE_MANAGER_DASHBOARD_DEFAULT_ACCESS))
              })]
            })]
          }));
        }
      })
    });
  }
}
Dashboard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  imgToEditSelected: PropTypes.bool.isRequired,
  objects: PropTypes.instanceOf(Immutable.List).isRequired,
  location: PropTypes.object.isRequired,
  currentFolder: PropTypes.instanceOf(Immutable.Map),
  fileDetailsId: PropTypes.number,
  folderId: PropTypes.number,
  searchQuery: PropTypes.string,
  status: PropTypes.oneOf(Object.keys(RequestStatus)).isRequired,
  fetchingMoreFiles: PropTypes.bool.isRequired,
  selectedFile: PropTypes.instanceOf(Immutable.Map),
  bulkSelectedObjectIds: PropTypes.instanceOf(Immutable.Set).isRequired,
  total: PropTypes.number.isRequired,
  hasVideoIntegrationScope: PropTypes.bool.isRequired,
  hasFileManagerAccess: PropTypes.bool.isRequired,
  areFilesUploading: PropTypes.bool.isRequired,
  hasAccessToAsset: PropTypes.bool.isRequired,
  pageSize: PropTypes.number.isRequired,
  isUngatedForBackendPoweredPagination: PropTypes.bool.isRequired
};
const mapStateToProps = (state, props) => {
  const {
    objects,
    total
  } = getCurrentPageOfFoldersAndFiles(state, props);
  return {
    objects,
    total,
    status: getFetchFilesAndFoldersRequestStatus(state),
    fetchingMoreFiles: getIsFetchingMoreFilesAndFolders(state),
    selectedFile: getSelectedFile(state),
    bulkSelectedObjectIds: getSelectedObjectIds(state),
    currentFolder: getCurrentFolder(state, props),
    fileDetailsId: getFileDetailsIdFromUrl(state, props),
    folderId: getFolderIdFromUrl(state, props),
    searchQuery: getSearchQueryFromUrl(state, props),
    emailAddress: getUserEmailAddress(state),
    hasVideoIntegrationScope: getHasVideoIntegrationScope(state),
    hasFileManagerAccess: getHasFileManagerAccessScope(state),
    imgToEditSelected: getSelectedImageToEdit(state),
    areFilesUploading: getAreFilesUploading(state),
    pageSize: getPageSize(state),
    hasAccessToAsset: getHasAccessToFolder(state, props),
    isUngatedForBackendPoweredPagination: selectIsUngatedForBackendPoweredPagination(state)
  };
};
export default connect(mapStateToProps)(Dashboard);